import Error from "next/error"
import React from "react"
import ExhibitionsPage from "../../features/pages/ExhibitionsPage"
import galleryApiService from "../../services/galleryApiService"

const Exhibitions = ({ exhibitions, errorCode }) => {
  if (errorCode) {
    return <Error statusCode={404} />
  }

  return <ExhibitionsPage exhibitions={exhibitions} />
}

export const getServerSideProps = async () => {
  const response = await galleryApiService.exhibitions()

  return {
    props: {
      errorCode: !response.data,
      exhibitions: response.data,
    },
  }
}

export default Exhibitions
